import { useUserStore } from '@/store/user/user'

import { VkAuthSuccessCallbackProps } from '@/services/vk/types'

export const authByVk = async (payload: VkAuthSuccessCallbackProps) => {
  const { $sentryCaptureException } = useNuxtApp()
  const { $metrics } = useNuxtApp()
  const { name } = useRoute()
  const { go } = useRouter()
  const { authByVk } = useUserStore()

  const result = await authByVk(payload)

  if (result instanceof Error) {
    $sentryCaptureException(result)

    return
  }

  $metrics?.eventSendGoal({ ym: 'vk_auth' })

  if (name === 'login') {
    window.location.href = window.location.origin
  } else {
    go(0)
  }
}
